<template>
  <div>
    
    <el-form-item :label="title">
      <!-- `el-date-picker`, come nel gestionale admin: il calendario si apre
           sopra la pagina, non tagliato dai bordi della scheda. Il valore resta una
           Date in ora locale. Avvolto in CampoData, che lo apre cliccando su
           tutto il campo e non solo sull'icona. -->
      <CampoData
        v-model="datePartner"
        type="date"
        format="DD/MM/YYYY"
        placeholder="Scegli la data"
        class="dsc__date"
        :class="{ highlight: highlightDate }"
        :clearable="false"
        :editable="false"
        :disabled="dateDisabled"
        :disabled-date="disabledDates"
      />
    </el-form-item>
  </div>
  <div>
    <!-- Etichetta della fascia oraria, facoltativa: vuota (il default) resta il
         solo segnaposto «Ora». -->
    <el-form-item :label="slotTitle">
      <el-cascader
        v-model="selectedSlot"
        :placeholder="loading ? 'Loading...' : 'Ora'"
        :options="timeSlots"
        :props="{ value: 'value', label: 'label', disabled: 'disabled' }"
        popper-class="custom-popper"
        :disabled="loading"
        :class="{ highlight: highlightSlot }"
      />
    </el-form-item>
  </div>
</template>

<script>
import CampoData from './ui/CampoData.vue';

export default {
  components: { CampoData },
  props: {
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    timeSlots: {
      type: Array,
      required: true,
    },
    highlightSlot: {
      type: Boolean,
      required: true,
    },
    dateDisabled: {
      type: Boolean,
      required: true,
    },
    highlightDate: {
      type: Boolean,
      required: true,
    },
    disabledDates: {
      required: false,
      type: Function,
    },
    selectedSlotInput: {},

    /** Etichetta del campo fascia oraria. Vuota = nessuna etichetta. */
    slotTitle: {
      type: String,
      required: false,
      default: '',
    },

    /**
     * Data da mostrare già scelta, in forma `YYYY-MM-DD`: arriva dal calendario
     * dell'Agenda. Impostarla equivale a sceglierla a mano, quindi il genitore
     * riceve `datePartnerChange` come sempre e carica gli slot da sé.
     */
    selectedDate: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      selectedSlot: null,
      datePartner: '',
    };
  },
  watch: {
    selectedSlot(val) {
      this.$emit('selectedSlot', val);
    },
    datePartner(val) {
      this.$emit('datePartnerChange', val);
    },

    selectedSlotInput: {
      immediate: true,
      handler(newVal) {
        this.selectedSlot = newVal;
      },
    },

    selectedDate: {
      immediate: true,
      handler() {
        this.applicaDataIniziale();
      },
    },

    // ⚠️ Il campo nasce DISABILITATO finché non sono scelti cliente e sede: senza
    // quelli il calcolo degli slot non ha i dati per rispondere. Una data passata
    // da fuori resta in attesa e si applica appena il campo diventa scrivibile.
    dateDisabled: {
      immediate: true,
      handler(disabilitato) {
        if (!disabilitato) this.applicaDataIniziale();
      },
    },
  },
  methods: {
    applicaDataIniziale() {
      if (this.dateDisabled) return;
      const v = String(this.selectedDate || '');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return;
      // ⚠️ Si costruisce la Date dai pezzi, in ora LOCALE. `new Date('2026-09-15')`
      // sarebbe interpretata come UTC: su fusi a ovest di Greenwich il
      // calendario mostrerebbe il giorno PRIMA di quello cliccato.
      const [a, m, g] = v.split('-').map(Number);
      const nuova = new Date(a, m - 1, g);
      if (this.datePartner instanceof Date
        && this.datePartner.getTime() === nuova.getTime()) return;
      this.datePartner = nuova;
    },
  },
};
</script>

<style scoped>
/* `:deep` perché il picker ora è figlio di CampoData: senza, lo scope di questo
   componente non lo raggiunge più. Il cascader resta figlio diretto. */
:deep(.dsc__date) { width: 100%; }
/* Campo da compilare: bordo rosso, come gli altri campi del form. */
.highlight :deep(.el-input__wrapper),
:deep(.dsc__date.highlight .el-input__wrapper) { box-shadow: 0 0 0 1px var(--el-color-danger) inset; }
</style>
